import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { Layout } from "antd";
import blogCover from "./images/blogcov.jpg";
import {
  HomeOutlined,
  ReadOutlined,
  BookOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import Home from "./components/home";
import Books from "./components/BooksAuthors";
import Resources from "./components/ChristianResources";
import Blog from "./components/Blog";
import PostGalleryWithActions from "./components/Art_Gallery";
import BlogDetail from "./components/BlogDetail ";
import BlogManager from "./components/blogs_manager";
import PostManager from "./components/art_manager";

import "./App.css";

const { Header, Content } = Layout;

const App = () => {

  const cardData = [
    {
      title: "All Blogs",
      icon: <ReadOutlined className="card-icon" />,
      link: "/blog",
      style: {
        backgroundImage: `url(${blogCover})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff"
      }
    }
    ,
    {
      title: "Our Art Gallery",
      icon: <BookOutlined className="card-icon" />,
      link: "/art-gallary",
    },
    {
      title: "Books & Authors",
      icon: <BookOutlined className="card-icon" />,
      link: "/books-authors",
    },
    {
      title: "Christian Resources",
      icon: <ShareAltOutlined className="card-icon" />,
      link: "/christian-resources",
    },
  ];


  return (
    <Router>
      <Layout style={{ minHeight: "100vh" }}>
        <Header className="header">
          <div className="logo-container">
            <Link to="/" className="logo-text">
              <img
                src={require("./images/Bowlicon.png")}
                alt="Bowl Icon"
                className="logo-image"
              />
              Her Cup Overflows
            </Link>
          </div>

          <nav className="header-nav">
            <Link to="/" className="nav-link">
              <HomeOutlined className="nav-icon" /> Home
            </Link>
          </nav>

          {/* <div className="header-right">
            <Dropdown overlay={menu} placement="bottomRight">
              <GlobalOutlined className="translate-icon" />
            </Dropdown>
            <div id="google_translate_element" style={{ display: "none" }}></div>
          </div> */}
        </Header>

        <Content className="content-area">
          <Routes>
            <Route path="/" element={<Home cardData={cardData} />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/books-authors" element={<Books />} />
            <Route path="/christian-resources" element={<Resources />} />
            <Route path="/blogs_manager" element={<BlogManager />} />
            <Route path="/post_manager" element={<PostManager />} />
            <Route path="/art-gallary" element={<PostGalleryWithActions />} />


          </Routes>
        </Content>
      </Layout>
    </Router>
  );
};

export default App;
